import { render, staticRenderFns } from "./PluginAdd.vue?vue&type=template&id=07f2218b&"
import script from "./PluginAdd.vue?vue&type=script&lang=js&"
export * from "./PluginAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports